import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsInlineSkateNormalMedium = React.forwardRef(
  ({ color = "currentColor", size = 32, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M3.5 0v.195A2.75 2.75 0 004.753 2.5L7.745.625A3.917 3.917 0 0111.13.251l5.258 1.859a3.917 3.917 0 012.61 3.692V6H20v2.5h-.873c.195.887.61 1.712 1.208 2.397l.781-.78 1.768 1.767-.634.634.34.265c.54.424 1.168.722 1.838.874l.807.182A6.116 6.116 0 0130 19.804a3.191 3.191 0 01-1.231 2.521 2.86 2.86 0 01.191 1.993 3.5 3.5 0 11-4.815 2.182h-1.29a3.5 3.5 0 11-6.71 0h-1.29a3.5 3.5 0 11-6.71 0h-1.29a3.5 3.5 0 11-5.829-1.476 2.893 2.893 0 01-.23-2.363l1.072-3.217a8.09 8.09 0 01-.645-5.45l2.182-9.387A5.25 5.25 0 011 .195V0zm6.798 2.608a1.417 1.417 0 00-1.225.135l-3.095 1.94a.083.083 0 00-.037.052l-1.26 5.427 3.362 3.363c.61.61 1.618.538 2.135-.152L12.708 10h4.254a7.922 7.922 0 01-.376-1.5H9V6h7.5v-.198c0-.6-.379-1.135-.945-1.335zm8.119 9.892h-4.459l-1.78 2.373a3.917 3.917 0 01-5.903.42l-2.261-2.262-.356 1.529a5.59 5.59 0 00.537 3.94H9.39c2.3 0 3.515.595 4.596 1.13l.019.01c.931.46 1.74.86 3.468.86h9.33a.696.696 0 00.697-.696c0-1.69-1.17-3.153-2.817-3.526l-.807-.183a7.149 7.149 0 01-2.827-1.343l-.58-.453-3.585 3.585-1.768-1.768 3.449-3.449c-.05-.055-.1-.11-.148-.167zM3.167 23.452c-.09.27.111.548.395.548h22.574c.333 0 .531-.37.346-.648L26.248 23h-8.775c-2.301 0-3.515-.595-4.596-1.13l-.02-.009c-.93-.461-1.739-.86-3.467-.86H3.984z"
        fill=""
      />
    </svg>
  )
);
SvgSportsInlineSkateNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsInlineSkateNormalMedium;
